// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function Stamp(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Stamp" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M3 18H21V21H3V18Z", fill: "currentColor" }),
            React.createElement("path", { d: "M9.32235 11L10 14H14L14.6776 11H21V17H3V11H9.32235Z", fill: "currentColor" }),
            React.createElement("path", { d: "M15 5.07099C15 3.37486 13.6569 2 12 2C10.3431 2 9 3.37486 9 5.07099L11 13H13L15 5.07099Z", fill: "currentColor" }))));
});
//# sourceMappingURL=Stamp.js.map